export {
  cilPeople,
  cilNotes,
  cilSchool,
  cilUser,
  cilReportSlash,
  cilChart,
  cilInstitution,
  cilSearch,
  cilCheck,
  cilSpreadsheet,
  cilFile,
  cilTrash,
  cilPencil,
  cilAddressBook,
  cilCloudDownload,
  cilCloudUpload,
  cilPlus,
  cilDescription,
  cilCopy,
  cilArrowTop,
  cilArrowBottom,
  cilSun,
  cilMoon,
  cilContrast,
  cilAccountLogout,
  cilMenu,
  cilCalendar,
  cilLocationPin,
  cilHome,
  cibSkype,
  cilList,
  cilSpeech,
  cilSettings,
  cilCart,
  cilFolder,
  cilFolderOpen,
  cilLockLocked
} from '@coreui/icons';
